import { createReducer, on } from '@ngrx/store';
import * as CommunityProductActions from './community-product-category.action';
import { CommunityProductCategory } from '../../models/community-product-category';


export interface CommunityProductCategoryState {
  communityProductCategory: CommunityProductCategory[];
  loading: boolean;
  error: any;
}

export const initialState: CommunityProductCategoryState = {
  communityProductCategory: [],
  loading: false,
  error: null,
};

export const communityProductCategoryReducer = createReducer(
  initialState,
  on(CommunityProductActions.loadCommunityProductCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CommunityProductActions.loadCommunityProductCategorySuccess, (state, { communityProductCategory }) => ({
    ...state,
    communityProductCategory,
    loading: false,
  })),
  on(CommunityProductActions.loadCommunityProductCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);